/**
 * Export java class to js module
 */

import { NativeModules, Platform } from 'react-native';

module.exports = NativeModules.SharedStorage;